import MuiMenu, { MenuProps } from "@mui/material/Menu";
import { handleKeyDown } from "core/model/accessibility/keyboardActions";

export const Menu = ({ children, onClick, onClose, ...props }: MenuProps) => {
  return (
    <MuiMenu
      {...props}
      autoFocus={true}
      tabIndex={0}
      TransitionProps={{
        onKeyDown: handleKeyDown({
          onCancel: (event) => {
            onClose?.(event, "escapeKeyDown");
          },
          onConfirm: (event) => {
            onClick?.(
              event as unknown as React.MouseEvent<HTMLDivElement, MouseEvent>,
            );
          },
        }),
      }}
      onClick={onClick}
      onClose={onClose}
    >
      {children}
    </MuiMenu>
  );
};
